import { render, staticRenderFns } from "./TenantEditPayments.vue?vue&type=template&id=4a3661a9&scoped=true&"
import script from "./TenantEditPayments.vue?vue&type=script&lang=js&"
export * from "./TenantEditPayments.vue?vue&type=script&lang=js&"
import style0 from "./TenantEditPayments.vue?vue&type=style&index=0&id=4a3661a9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3661a9",
  null
  
)

export default component.exports